import { AssetTree, TreeCategory } from "@rio-cloud/rio-uikit";
import { useState } from "react";
import CategoryTree from "./OptionsTree/CategoryTree";
import ClientTree from "./OptionsTree/ClientTree";
import ContractTree from "./OptionsTree/ContractTree";
import VehicleTree from "./OptionsTree/VehicleTree";
import useAssetTree from "./useAssetTree";
import { useAppDispatch } from "@store";

const CATEGORY = "category";
const CLIENT = "client";
const CONTRACT = "contract";
const VEHICLE = "vehicle";

const CustomAssetTree = () => {
  const dispatch = useAppDispatch();
  const TreeCategoryComponent = TreeCategory as React.ComponentType<any>;

  const [isOpen, setIsOpen] = useState(false);
  const [currentCategoryId, setCurrentCategoryId] = useState(CATEGORY);

  const handleChangeCategories = (categoryId: string) => setCurrentCategoryId(categoryId);

  const {
    filterOptions,
    selectedCategories,
    selectedClients,
    selectedContracts,
    selectedVehicles,

    setSelectedClients,
    setSelectedContracts,
    setSelectedVehicles,
    setSelectedCategories,
  } = useAssetTree();

  return (
    <AssetTree
      minWidth={0}
      maxWidth={350}
      currentCategoryId={currentCategoryId}
      onCategoryChange={handleChangeCategories}
      isOpen={isOpen}
      onToggleTree={(open) => {
        setIsOpen(open);
      }}
      useOffscreen={false}
    >
      <TreeCategoryComponent
        key={CATEGORY}
        id={CATEGORY}
        label="Categoria"
        icon="rioglyph rioglyph-tag"
        hasSelection={!!selectedCategories.length}
      >
        <CategoryTree
          filterOptions={filterOptions}
          selectedCategories={selectedCategories}
          setSelectedCategories={(items) => dispatch(setSelectedCategories(items))}
        />
      </TreeCategoryComponent>
      <TreeCategoryComponent
        key={CLIENT}
        id={CLIENT}
        label="Cliente"
        icon="rioglyph rioglyph-transfer"
        hasSelection={!!selectedClients.length}
      >
        <ClientTree
          filterOptions={filterOptions}
          selectedClients={selectedClients}
          setSelectedClients={(items) => dispatch(setSelectedClients(items))}
        />
      </TreeCategoryComponent>
      <TreeCategoryComponent
        key={CONTRACT}
        id={CONTRACT}
        label="Contrato"
        icon="rioglyph rioglyph-file-signature"
        hasSelection={!!selectedContracts.length}
      >
        <ContractTree
          filterOptions={filterOptions}
          selectedContracts={selectedContracts}
          setSelectedContracts={(items) => dispatch(setSelectedContracts(items))}
        />
      </TreeCategoryComponent>
      <TreeCategoryComponent
        key={VEHICLE}
        id={VEHICLE}
        label="Veículo"
        icon="rioglyph rioglyph-van-baseline"
        hasSelection={!!selectedVehicles.length}
      >
        <VehicleTree
          filterOptions={filterOptions}
          selectedVehicles={selectedVehicles}
          setSelectedVehicles={(items) => dispatch(setSelectedVehicles(items))}
        />
      </TreeCategoryComponent>
    </AssetTree>
  );
};

export default CustomAssetTree;
